export enum AssetPieChartGroupBy {
    asset = "asset",
    token = "token",
    assetClass = "assetClass",
    issuer = "issuer",
    jurisdictionCountry = "jurisdiction_country",
    measure = "measure",
    network = "network",
    peggedAsset = "pegged_asset",
    manager = "manager",
    protocol = "protocol",
    realEstateCountry = "real_estate_country",
}
